module.exports = __webpack_public_path__ + "assets/e6bc6b7311c789f0eda2ead897cd0ef7.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/buttons/denoms/denom-11.mp3
 ** module id = 354
 ** module chunks = 0
 **/